import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PrepareGuard } from 'app/core/prepare.guard';
import { BasicLayoutComponent } from 'app/common/layouts/basicLayout.component';
import { VendorOverviewComponent } from './vendor-overview/vendor-overview.component';
import { VendorDetailComponent } from './vendor-detail/vendor-detail.component';
import { PendingChangesGuard } from 'app/core/pending-changes.guard';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from 'app/shared/shared.module';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        RouterModule.forChild([
            {
                path: 'vendors',
                canActivate: [PrepareGuard],
                component: BasicLayoutComponent,
                children: [
                    {
                        path: 'overview',
                        component: VendorOverviewComponent,
                        data: { title: 'Vendor Overview' },
                        canActivate: [PrepareGuard],
                    },
                    {
                        path: ':id',
                        component: VendorDetailComponent,
                        data: { title: 'Vendor' },
                        canDeactivate: [PendingChangesGuard],
                    },
                ],
            },
        ]),
    ],
    declarations: [VendorOverviewComponent, VendorDetailComponent],
})
export class VendorModule {}
